exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.periodes[data-v-3b41a630] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\nh3[data-v-3b41a630] {\n  text-align: center;\n}\n", ""]);
